import React from 'react';
import styled from 'styled-components';
import { Check } from '@material-ui/icons';
import { BLUE } from '../../AnalyticsV2.styled';

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-left: 12px;
  padding: 0;
  border: none;
  background: none;
  font-size: 15px;
  color: ${BLUE};
  cursor: pointer;
  white-space: nowrap;
`;

// A rounded square, filled with a check mark when on, as in the design.
const Box = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border: 1.5px solid ${BLUE};
  border-radius: 6px;
  background: ${({ $checked }) => ($checked ? BLUE : 'transparent')};
`;

// "Show selected messages only" in the table header.
const ShowSelectedToggle = ({ checked, onChange }) => (
  <Button
    type="button"
    role="checkbox"
    aria-checked={checked}
    onClick={() => onChange(!checked)}
  >
    <Box $checked={checked}>
      {checked && <Check style={{ fontSize: 16, color: '#ffffff' }} />}
    </Box>
    Show selected messages only
  </Button>
);

export default ShowSelectedToggle;
